import './CodeHighlight.scss';
import classNames from 'classnames';
import { CodeItem } from './CodeItem';
import React from 'react';
export const CodeHighlight = ({ code, codeReferences, index, isNested }) => {
    if (!code) {
        return null;
    }
    const classes = classNames('code-highlight', {
        nested: isNested
    });
    const references = codeReferences.map((ref) => {
        const { sonarObjectId, sonarObjectType, startChar, endChar } = ref;
        const periscopeOptions = sonarObjectId ? {
            id: sonarObjectId,
            name: '',
            openedFromIndex: index,
            type: sonarObjectType
        } : undefined;
        return {
            end: endChar,
            periscopeOptions,
            start: startChar
        };
    });
    return (React.createElement("div", { className: classes },
        React.createElement(CodeItem, { code: code, sections: references })));
};
